import * as pdfjsLib from 'pdfjs-dist';
import { getFileFormatInfo } from './fileFormat';

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

/** Sum page counts for PDF files only; non-PDFs contribute 0. */
export async function sumPdfPagesInFiles(files: File[]): Promise<number> {
  let sum = 0;
  for (const file of files) {
    const info = getFileFormatInfo(file.name);
    if (!info.isPDF && file.type !== 'application/pdf') continue;
    try {
      const buf = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: buf }).promise;
      sum += pdf.numPages;
    } catch {
      /* skip unreadable pdf */
    }
  }
  return sum;
}
